export interface Country {
  code: string
  name: string
  flag: string
}

export const COUNTRIES: Country[] = [
  // Latin America (priority)
  { code: "AR", name: "Argentina", flag: "\u{1F1E6}\u{1F1F7}" },
  { code: "BO", name: "Bolivia", flag: "\u{1F1E7}\u{1F1F4}" },
  { code: "BR", name: "Brasil", flag: "\u{1F1E7}\u{1F1F7}" },
  { code: "CL", name: "Chile", flag: "\u{1F1E8}\u{1F1F1}" },
  { code: "CO", name: "Colombia", flag: "\u{1F1E8}\u{1F1F4}" },
  { code: "CR", name: "Costa Rica", flag: "\u{1F1E8}\u{1F1F7}" },
  { code: "CU", name: "Cuba", flag: "\u{1F1E8}\u{1F1FA}" },
  { code: "DO", name: "República Dominicana", flag: "\u{1F1E9}\u{1F1F4}" },
  { code: "EC", name: "Ecuador", flag: "\u{1F1EA}\u{1F1E8}" },
  { code: "SV", name: "El Salvador", flag: "\u{1F1F8}\u{1F1FB}" },
  { code: "GT", name: "Guatemala", flag: "\u{1F1EC}\u{1F1F9}" },
  { code: "HN", name: "Honduras", flag: "\u{1F1ED}\u{1F1F3}" },
  { code: "MX", name: "México", flag: "\u{1F1F2}\u{1F1FD}" },
  { code: "NI", name: "Nicaragua", flag: "\u{1F1F3}\u{1F1EE}" },
  { code: "PA", name: "Panamá", flag: "\u{1F1F5}\u{1F1E6}" },
  { code: "PY", name: "Paraguay", flag: "\u{1F1F5}\u{1F1FE}" },
  { code: "PE", name: "Perú", flag: "\u{1F1F5}\u{1F1EA}" },
  { code: "PR", name: "Puerto Rico", flag: "\u{1F1F5}\u{1F1F7}" },
  { code: "UY", name: "Uruguay", flag: "\u{1F1FA}\u{1F1FE}" },
  { code: "VE", name: "Venezuela", flag: "\u{1F1FB}\u{1F1EA}" },
  // Europe
  { code: "ES", name: "España", flag: "\u{1F1EA}\u{1F1F8}" },
  { code: "PT", name: "Portugal", flag: "\u{1F1F5}\u{1F1F9}" },
  { code: "IT", name: "Italia", flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "FR", name: "Francia", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "DE", name: "Alemania", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "GB", name: "Reino Unido", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "NL", name: "Países Bajos", flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "BE", name: "Bélgica", flag: "\u{1F1E7}\u{1F1EA}" },
  { code: "AT", name: "Austria", flag: "\u{1F1E6}\u{1F1F9}" },
  { code: "CH", name: "Suiza", flag: "\u{1F1E8}\u{1F1ED}" },
  { code: "SE", name: "Suecia", flag: "\u{1F1F8}\u{1F1EA}" },
  { code: "NO", name: "Noruega", flag: "\u{1F1F3}\u{1F1F4}" },
  { code: "DK", name: "Dinamarca", flag: "\u{1F1E9}\u{1F1F0}" },
  { code: "PL", name: "Polonia", flag: "\u{1F1F5}\u{1F1F1}" },
  { code: "HR", name: "Croacia", flag: "\u{1F1ED}\u{1F1F7}" },
  { code: "RS", name: "Serbia", flag: "\u{1F1F7}\u{1F1F8}" },
  { code: "GR", name: "Grecia", flag: "\u{1F1EC}\u{1F1F7}" },
  { code: "TR", name: "Turquía", flag: "\u{1F1F9}\u{1F1F7}" },
  // Africa
  { code: "NG", name: "Nigeria", flag: "\u{1F1F3}\u{1F1EC}" },
  { code: "GH", name: "Ghana", flag: "\u{1F1EC}\u{1F1ED}" },
  { code: "SN", name: "Senegal", flag: "\u{1F1F8}\u{1F1F3}" },
  { code: "CM", name: "Camerún", flag: "\u{1F1E8}\u{1F1F2}" },
  { code: "CI", name: "Costa de Marfil", flag: "\u{1F1E8}\u{1F1EE}" },
  { code: "MA", name: "Marruecos", flag: "\u{1F1F2}\u{1F1E6}" },
  { code: "EG", name: "Egipto", flag: "\u{1F1EA}\u{1F1EC}" },
  { code: "ZA", name: "Sudáfrica", flag: "\u{1F1FF}\u{1F1E6}" },
  // North America
  { code: "US", name: "Estados Unidos", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "CA", name: "Canadá", flag: "\u{1F1E8}\u{1F1E6}" },
  // Asia/Oceania
  { code: "JP", name: "Japón", flag: "\u{1F1EF}\u{1F1F5}" },
  { code: "KR", name: "Corea del Sur", flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "AU", name: "Australia", flag: "\u{1F1E6}\u{1F1FA}" },
  { code: "NZ", name: "Nueva Zelanda", flag: "\u{1F1F3}\u{1F1FF}" },
]

export const PROVINCES: Record<string, string[]> = {
  AR: [
    "Buenos Aires",
    "CABA",
    "Catamarca",
    "Chaco",
    "Chubut",
    "Córdoba",
    "Corrientes",
    "Entre Ríos",
    "Formosa",
    "Jujuy",
    "La Pampa",
    "La Rioja",
    "Mendoza",
    "Misiones",
    "Neuquén",
    "Río Negro",
    "Salta",
    "San Juan",
    "San Luis",
    "Santa Cruz",
    "Santa Fe",
    "Santiago del Estero",
    "Tierra del Fuego",
    "Tucumán",
  ],
  CO: [
    "Amazonas",
    "Antioquia",
    "Arauca",
    "Atlántico",
    "Bogotá D.C.",
    "Bolívar",
    "Boyacá",
    "Caldas",
    "Caquetá",
    "Casanare",
    "Cauca",
    "Cesar",
    "Chocó",
    "Córdoba",
    "Cundinamarca",
    "Guainía",
    "Guaviare",
    "Huila",
    "La Guajira",
    "Magdalena",
    "Meta",
    "Nariño",
    "Norte de Santander",
    "Putumayo",
    "Quindío",
    "Risaralda",
    "San Andrés y Providencia",
    "Santander",
    "Sucre",
    "Tolima",
    "Valle del Cauca",
    "Vaupés",
    "Vichada",
  ],
  MX: [
    "Aguascalientes",
    "Baja California",
    "Baja California Sur",
    "Campeche",
    "Chiapas",
    "Chihuahua",
    "Ciudad de México",
    "Coahuila",
    "Colima",
    "Durango",
    "Estado de México",
    "Guanajuato",
    "Guerrero",
    "Hidalgo",
    "Jalisco",
    "Michoacán",
    "Morelos",
    "Nayarit",
    "Nuevo León",
    "Oaxaca",
    "Puebla",
    "Querétaro",
    "Quintana Roo",
    "San Luis Potosí",
    "Sinaloa",
    "Sonora",
    "Tabasco",
    "Tamaulipas",
    "Tlaxcala",
    "Veracruz",
    "Yucatán",
    "Zacatecas",
  ],
  CL: [
    "Arica y Parinacota",
    "Tarapacá",
    "Antofagasta",
    "Atacama",
    "Coquimbo",
    "Valparaíso",
    "Metropolitana de Santiago",
    "O'Higgins",
    "Maule",
    "Ñuble",
    "Biobío",
    "Araucanía",
    "Los Ríos",
    "Los Lagos",
    "Aysén",
    "Magallanes",
  ],
  PE: [
    "Amazonas",
    "Áncash",
    "Apurímac",
    "Arequipa",
    "Ayacucho",
    "Cajamarca",
    "Callao",
    "Cusco",
    "Huancavelica",
    "Huánuco",
    "Ica",
    "Junín",
    "La Libertad",
    "Lambayeque",
    "Lima",
    "Loreto",
    "Madre de Dios",
    "Moquegua",
    "Pasco",
    "Piura",
    "Puno",
    "San Martín",
    "Tacna",
    "Tumbes",
    "Ucayali",
  ],
  EC: [
    "Azuay",
    "Bolívar",
    "Cañar",
    "Carchi",
    "Chimborazo",
    "Cotopaxi",
    "El Oro",
    "Esmeraldas",
    "Galápagos",
    "Guayas",
    "Imbabura",
    "Loja",
    "Los Ríos",
    "Manabí",
    "Morona Santiago",
    "Napo",
    "Orellana",
    "Pastaza",
    "Pichincha",
    "Santa Elena",
    "Santo Domingo de los Tsáchilas",
    "Sucumbíos",
    "Tungurahua",
    "Zamora Chinchipe",
  ],
  UY: [
    "Artigas",
    "Canelones",
    "Cerro Largo",
    "Colonia",
    "Durazno",
    "Flores",
    "Florida",
    "Lavalleja",
    "Maldonado",
    "Montevideo",
    "Paysandú",
    "Río Negro",
    "Rivera",
    "Rocha",
    "Salto",
    "San José",
    "Soriano",
    "Tacuarembó",
    "Treinta y Tres",
  ],
  PY: [
    "Alto Paraguay",
    "Alto Paraná",
    "Amambay",
    "Asunción",
    "Boquerón",
    "Caaguazú",
    "Caazapá",
    "Canindeyú",
    "Central",
    "Concepción",
    "Cordillera",
    "Guairá",
    "Itapúa",
    "Misiones",
    "Ñeembucú",
    "Paraguarí",
    "Presidente Hayes",
    "San Pedro",
  ],
  BO: [
    "Beni",
    "Chuquisaca",
    "Cochabamba",
    "La Paz",
    "Oruro",
    "Pando",
    "Potosí",
    "Santa Cruz",
    "Tarija",
  ],
  VE: [
    "Amazonas",
    "Anzoátegui",
    "Apure",
    "Aragua",
    "Barinas",
    "Bolívar",
    "Carabobo",
    "Cojedes",
    "Delta Amacuro",
    "Distrito Capital",
    "Falcón",
    "Guárico",
    "Lara",
    "Mérida",
    "Miranda",
    "Monagas",
    "Nueva Esparta",
    "Portuguesa",
    "Sucre",
    "Táchira",
    "Trujillo",
    "Vargas",
    "Yaracuy",
    "Zulia",
  ],
  BR: [
    "Acre",
    "Alagoas",
    "Amapá",
    "Amazonas",
    "Bahia",
    "Ceará",
    "Distrito Federal",
    "Espírito Santo",
    "Goiás",
    "Maranhão",
    "Mato Grosso",
    "Mato Grosso do Sul",
    "Minas Gerais",
    "Pará",
    "Paraíba",
    "Paraná",
    "Pernambuco",
    "Piauí",
    "Rio de Janeiro",
    "Rio Grande do Norte",
    "Rio Grande do Sul",
    "Rondônia",
    "Roraima",
    "Santa Catarina",
    "São Paulo",
    "Sergipe",
    "Tocantins",
  ],
  ES: [
    "Andalucía",
    "Aragón",
    "Asturias",
    "Baleares",
    "Canarias",
    "Cantabria",
    "Castilla y León",
    "Castilla-La Mancha",
    "Cataluña",
    "Comunidad Valenciana",
    "Extremadura",
    "Galicia",
    "La Rioja",
    "Madrid",
    "Murcia",
    "Navarra",
    "País Vasco",
  ],
}

export function getProvincesForCountry(countryName: string): string[] {
  const country = COUNTRIES.find((c) => c.name === countryName)
  if (!country) return []
  return PROVINCES[country.code] ?? []
}

export function getCountryCode(countryName: string): string | undefined {
  return COUNTRIES.find((c) => c.name === countryName)?.code
}
